import {
    CREATE_ORDER_REQUEST,
    CREATE_ORDER_SUCCESS,
    CREATE_ORDER_FAIL,
    MY_ORDERS_REQUEST,
    MY_ORDERS_SUCCESS,
    MY_ORDERS_FAIL,
    ALL_ORDERS_REQUEST,
    ALL_ORDERS_SUCCESS,
    ALL_ORDERS_FAIL,
    UPDATE_ORDER_REQUEST,
    UPDATE_ORDER_SUCCESS,
    UPDATE_ORDER_FAIL,
    UPDATE_ORDER_RESET,
    DELETE_ORDER_REQUEST,
    DELETE_ORDER_SUCCESS,
    DELETE_ORDER_FAIL,
    DELETE_ORDER_RESET,
    RESEND_ORDER_EMAILS_REQUEST,
    RESEND_ORDER_EMAILS_SUCCESS,
    RESEND_ORDER_EMAILS_FAIL,
    ORDER_DETAILS_REQUEST,
    ORDER_DETAILS_SUCCESS,
    ORDER_DETAILS_FAIL,
    CLEAR_ERRORS,
  } from "../constants/orderConstants";
  
  export const newOrderReducer = (state = {}, action) => {
    switch (action.type) {
      case CREATE_ORDER_REQUEST:
        return {
          ...state,
          loading: true,
        };
  
      case CREATE_ORDER_SUCCESS:
        // Backend returns: { success: true, order: {...} }
        // Extract order from payload
        console.log('🔵 [ORDER_REDUCER] CREATE_ORDER_SUCCESS received');
        console.log('🔵 [ORDER_REDUCER] Action payload:', JSON.stringify(action.payload, null, 2));
        const orderData = action.payload.order || action.payload;
        console.log('🔵 [ORDER_REDUCER] Extracted order data:', {
          hasOrder: !!orderData,
          orderId: orderData?._id,
          orderTotal: orderData?.totalPrice,
          orderStatus: orderData?.orderStatus
        });
        
        const newState = {
          ...state, // Preserve existing state
          loading: false,
          order: orderData,
          success: action.payload.success !== false && (action.payload.success === true || action.payload.success === undefined), // Preserve success flag
          error: null, // Clear any previous errors
          // Also preserve full payload for debugging
          fullPayload: action.payload,
        };
        
        console.log('🔵 [ORDER_REDUCER] New state being set:', {
          hasOrder: !!newState.order,
          orderId: newState.order?._id,
          success: newState.success,
          loading: newState.loading
        });
        
        return newState;
  
      case CREATE_ORDER_FAIL:
        return {
          loading: false,
          error: action.payload,
        };
      case CLEAR_ERRORS:
        return {
          ...state,
          error: null,
        };
  
      default:
        return state;
    }
  };
  
  export const myOrdersReducer = (state = { orders: [] }, action) => {
    switch (action.type) {
      case MY_ORDERS_REQUEST:
        console.log('🔵 [ORDER_REDUCER] MY_ORDERS_REQUEST');
        return {
          ...state,
          loading: true,
          error: null,
        };
  
      case MY_ORDERS_SUCCESS:
        console.log('✅ [ORDER_REDUCER] MY_ORDERS_SUCCESS');
        console.log('🔵 [ORDER_REDUCER] Orders received:', action.payload?.length || 0);
        console.log('🔵 [ORDER_REDUCER] Orders payload:', action.payload);
        return {
          ...state,
          loading: false,
          orders: action.payload || [],
          error: null,
        };
  
      case MY_ORDERS_FAIL:
        console.error('❌ [ORDER_REDUCER] MY_ORDERS_FAIL:', action.payload);
        return {
          ...state,
          loading: false,
          error: action.payload,
          orders: state.orders || [], // Preserve existing orders on error
        };
      case CLEAR_ERRORS:
        return {
          ...state,
          error: null,
        };
  
      default:
        return state;
    }
  };
  
  export const allOrdersReducer = (state = { orders: [] }, action) => {
    switch (action.type) {
      case ALL_ORDERS_REQUEST:
        console.log('🔵 [ORDER_REDUCER] ALL_ORDERS_REQUEST');
        return {
          ...state,
          loading: true,
          error: null,
        };
  
      case ALL_ORDERS_SUCCESS:
        console.log('✅ [ORDER_REDUCER] ALL_ORDERS_SUCCESS');
        console.log('🔵 [ORDER_REDUCER] Orders received:', action.payload?.length || 0);
        console.log('🔵 [ORDER_REDUCER] Orders payload:', action.payload);
        return {
          ...state,
          loading: false,
          orders: action.payload || [],
          error: null,
        };
  
      case ALL_ORDERS_FAIL:
        console.error('❌ [ORDER_REDUCER] ALL_ORDERS_FAIL:', action.payload);
        return {
          ...state,
          loading: false,
          error: action.payload,
          orders: state.orders || [], // Preserve existing orders on error
        };
      case CLEAR_ERRORS:
        return {
          ...state,
          error: null,
        };
  
      default:
        return state;
    }
  };
  
  export const orderReducer = (state = {}, action) => {
    switch (action.type) {
      case UPDATE_ORDER_REQUEST:
      case DELETE_ORDER_REQUEST:
      case RESEND_ORDER_EMAILS_REQUEST:
        return {
          ...state,
          loading: true,
        };
  
      case UPDATE_ORDER_SUCCESS:
        return {
          ...state,
          loading: false,
          isUpdated: action.payload,
        };
  
      case DELETE_ORDER_SUCCESS:
        return {
          ...state,
          loading: false,
          isDeleted: action.payload,
        };

      case RESEND_ORDER_EMAILS_SUCCESS:
        return {
          ...state,
          loading: false,
          emailResendResult: action.payload,
          error: null,
        };
  
      case UPDATE_ORDER_FAIL:
      case DELETE_ORDER_FAIL:
      case RESEND_ORDER_EMAILS_FAIL:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      case UPDATE_ORDER_RESET:
        return {
          ...state,
          isUpdated: false,
        };
  
      case DELETE_ORDER_RESET:
        return {
          ...state,
          isDeleted: false,
        };
      case CLEAR_ERRORS:
        return {
          ...state,
          error: null,
        };
  
      default:
        return state;
    }
  };
  
  export const orderDetailsReducer = (state = { order: {} }, action) => {
    switch (action.type) {
      case ORDER_DETAILS_REQUEST:
        return {
          loading: true,
        };
  
      case ORDER_DETAILS_SUCCESS:
        return {
          loading: false,
          order: action.payload,
        };
  
      case ORDER_DETAILS_FAIL:
        return {
          loading: false,
          error: action.payload,
        };
      case CLEAR_ERRORS:
        return {
          ...state,
          error: null,
        };
  
      default:
        return state;
    }
  };
